import * as React from "react"
import Svg, { Path } from "react-native-svg"
import { Icon } from 'native-base';

function SvgComponent(props) {
	return (
		<Icon
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 125.65 67.53"
			{...props}
		>
			<Path d="M17.82 53.08l-2.3 14.46H0L13.32 0h21.81l13.49 67.53H32.5l-2.37-14.46H17.81zm10.27-13.05c-1.53-9.85-3.01-20.84-3.87-27.05h-.51c-.66 6.48-2.31 17.2-3.91 27.05h8.28zM53.73 0h15.52v54.93h21.43l-1.45 12.61h-35.5V0zM96.92 12.7H83.6V0h42.05v12.7H112.4v54.84H96.92V12.7z" />
		</Icon>
	)
}

export default SvgComponent
